import clsx from "clsx"
import { ComponentPropsWithoutRef, forwardRef } from "react"

import Popover from "@molecules/Popover/Popover"

import styles from "./SelectViewport.module.scss"

function SelectViewport(props: ComponentPropsWithoutRef<typeof Popover.Viewport>) {
    const { children, className, ...rest } = props

    return (
        <Popover.Viewport className={clsx(styles.base, className)} {...rest} side="bottom" align="start">
            {children}
        </Popover.Viewport>
    )
}

export default forwardRef(SelectViewport)
